import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import { Navbar } from "./components/site/Navbar";
import { Footer } from "./components/site/Footer";
import { FloatingWhatsApp } from "./components/site/FloatingWhatsApp";
import { Toaster } from "sonner";

import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import ForRetailers from "./pages/ForRetailers";
import Coverage from "./pages/Coverage";
import Contact from "./pages/Contact";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Terms from "./pages/Terms";
import { LanguageProvider } from "./lib/i18n";

const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" });
    }, [pathname]);
    return null;
};

function App() {
    return (
        <div className="App">
            <LanguageProvider>
                <BrowserRouter>
                    <ScrollToTop />
                    <Navbar />
                    <main>
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/about" element={<About />} />
                            <Route path="/services" element={<Services />} />
                            <Route path="/retailers" element={<ForRetailers />} />
                            <Route path="/coverage" element={<Coverage />} />
                            <Route path="/contact" element={<Contact />} />
                            <Route path="/privacy" element={<PrivacyPolicy />} />
                            <Route path="/terms" element={<Terms />} />
                            <Route path="*" element={<Home />} />
                        </Routes>
                    </main>
                    <Footer />
                    <FloatingWhatsApp />
                    <Toaster position="top-center" richColors />
                </BrowserRouter>
            </LanguageProvider>
        </div>
    );
}

export default App;
